export default __webpack_public_path__ + "static/media/frame9.a342f1c5.jpg";